$(document).ready(function () {
    "use strict";

    $(document).on('click', '.js_readMoreSmallPrint', function(e) {
        e.preventDefault();
        $(this).prev().addClass('show');
        $(this).remove();
    });
});